function getRandomElement<T>(array: T[]): T {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}
  
function generateRandomString(length: number): string {
  const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export function generateRandomUsername(): string {
  const animals = [
    'otter', 'hedgehog', 'koala', 'panda', 'bunny',
    'penguin', 'quokka', 'raccoon', 'zebra', 
  ];

  const randomAnimal = getRandomElement(animals);
  const randomStringLength = 6
  const randomString = generateRandomString(randomStringLength);
  return `${randomAnimal}_${randomString}`;
}


export function getAnonymousUserId(): string {
  // Check if the user ID is already stored
  const storedUserId = localStorage.getItem('anonymousUserId');

  if (storedUserId) {
      return storedUserId; // Return the stored user ID if it exists
  }

  // Generate a new unique anonymous user ID
  const newUserId = `anon_${Math.random().toString(36).substr(2, 9)}`;

  // Store the new user ID in local storage
  localStorage.setItem('anonymousUserId', newUserId);
  
  return newUserId;
}

export function getAnonymousUsername(): string {
  const storedUsername = localStorage.getItem('anonymousUsername');

  if (storedUsername) {
      return storedUsername; // Return the stored username if it exists
  }

  const animals = [
      'Otter', 'Hedgehog', 'Koala', 'Panda', 'Bunny',
      'Quokka', 'Raccoon', 'Sloth', 'Fox', 'Rabbit',
      'Seal', 'Kitten', 'Puppy', 'Deer', 'Penguin',
      'Fawn', 'Pika', 'Ferret', 'Mole', 'Horse',
      'Dove', 'Lynx', 'Mink', 'Cub', 'Pony',
      'Lemur', 'Giraffe', 'Bear', 'Starfish', 'Lion',
      'Tiger', 'Panther', 'Bobcat', 'Squirrel', 'Chipmunk',
      'Salmon', 'Elk', 'Cinnabun', 'Moose', 'Robin',
      'Blue Jay', 'Chicken', 'Rooster', 'Chickadee', 'Kangaroo',
      'Duck', 'Goose', 'Swan', 'Toucan', 'Hare', 'Jackrabbit',
      'Worm', 'Caterpiller', 'Butterfly', 'Crab', 'Lobster', 'Shrimp',
      'Whale', 'Seahorse', 'Pig', 'Lamb', 'Sheep', 'Cow', 'Dog', 'Cat',
      'Hyena', 'Elephant', 'Monkey', 'Chimpanzee', 'Ape', 'Snake',
      'Grasshopper'
  ];

  const randomAnimal = getRandomElement(animals);
  const newUsername = `Anonymous ${randomAnimal}`;
  
  // Store the new username in local storage
  localStorage.setItem('anonymousUsername', newUsername);
  
  return newUsername;
}